import { kebabCase } from 'lodash-es';

export function deUmlaut(value: string): string {
  value = value.replace(/ä/g, 'ae');
  value = value.replace(/ö/g, 'oe');
  value = value.replace(/ü/g, 'ue');
  value = value.replace(/ß/g, 'ss');
  return value;
}

export function normalizeName(value: string): string {
  let result = deUmlaut(value);
  result = kebabCase(result);

  // console.log('normalizeNameForUrl', value, result);

  return result;
}

function padString(value: unknown, len: number, pad: string, direction: 'left' | 'right'): string {
  if (!value) {
    return value as string;
  }

  try {
    const s = value.toString();
    const numberOfPads = len - s.length;

    if (numberOfPads < 1) {
      return s;
    }

    let pads = '';
    while (pads.length < numberOfPads) {
      pads += pad;
    }

    return direction === 'left' ? `${pads}${s}` : `${s}${pads}`;
  } catch (e) {
    console.log(e);
    return value as string;
  }
}

export function leftPad(value: unknown, len = 1, pad = '0'): string {
  return padString(value, len, pad, 'left');
}

export function rightPad(value: unknown, len = 1, pad = '0'): string {
  return padString(value, len, pad, 'right');
}

export function capitalizeFirstLetter(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

export function countOcurrences(str: string, value: string): number {
  if (!str || !value) {
    return 0;
  }
  const regExp = new RegExp(value, 'gi');
  return (str.match(regExp) || []).length;
}

export function toFileName(value: string): string {
  return value?.replaceAll(' ', '_').toLowerCase();
}

export function replaceAllCustom(value: string, stringToFind: string, stringToReplace: string): string {
  if (value && stringToFind && stringToReplace) {
    return value.replaceAll(stringToFind, stringToReplace);
  } else {
    return value;
  }
}

export function contains(value: string, stringToFind: string): boolean {
  if (value && stringToFind) {
    const match = value.toLowerCase().indexOf(stringToFind.toLowerCase()) !== -1;
    return match;
  }
  return true;
}

/**
 * Liefert "filename" aus einem Response-Header
 *
 * z.B. 'content-disposition: data attachment; filename="hugo.xml"' -> 'hugo.xml'
 */
export function getFilenameFromHeader(header: string, defaultFilename: string): string {
  const parts = header.split('filename=');
  if (parts.length > 1) {
    const regex = new RegExp(`\"|'`, 'gi');
    const result = parts[1].replace(regex, '');
    return result;
  }
  return defaultFilename;
}

export function replaceLineBreaks(value: string, replaceMent: string) {
  return value ? value.replace(/(?:\r\n|\r|\n)/g, replaceMent) : undefined;
}

export function removeDots(num: string): string {
  return num.replace(/\./g, '');
}

/**
 * HTML entities decode
 */
export function decodeHtml(str: string): string {
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}

/**
 * Prüft ob ein String nur Ziffern enthält
 *
 */
export function containsOnlyDigits(str?: string): boolean {
  return /^\d+$/.test(str);
}

export function limitStringLength(value: string, limit: number, append = '...'): string {
  if (!value) {
    return '';
  }
  if (value.length > limit) {
    return `${value.substring(0, limit)} ${append}`;
  } else {
    return value;
  }
}

/**
 * Liefert entweder den uebergebenen "value" string wenn vorhanden oder einen leeren string
 *
 * @param value
 * @param suffix string der an value angehägt wird wenn value "vorhanden" ist
 */
export function defaultString(value: string | undefined | null, suffix = ''): string {
  return value ? `${value}${suffix}` : '';
}

export function checkLength(value: string | undefined, minLength: number, allowUndefined = false): boolean {
  if (!value) {
    return allowUndefined;
  }

  return value.length >= minLength;
}

export function displayString(value: unknown, fallback = ''): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (value === null || value === undefined) return fallback;
  return fallback;
}
